module.exports = __webpack_public_path__ + "img/logoESF.e8f046c6.svg";